import React, { useEffect, useState, useMemo } from 'react'
import { config } from '../../../../../config'
import axiosApi from '../../../../../core/interceptor/interceptor'
import { withRouter } from 'react-router-dom'
import { messages } from '../../../../../messages'
import '../Leads/Lead/AddLead.css'
import './AddTicket.css';
import CustomSelect from '../../../../../Util/CustomSelect/CustomSelect'
import {
  LEAD_STATUS,
  LEAGUE_STATUS,
  formatNumberToCurrency
} from '../../../../../Util/helper'
import NumberFormat from 'react-number-format'
import backArrow from '../../../../../assets/arrow-back.svg'
import { AsyncPaginate } from 'react-select-async-paginate'
import { phoneNumberMask } from '../../../../../Util/helper'
import add from '../../../../../assets/add-icon.svg'
import close from '../../../../../assets/close.svg'

function AddTicket(props) {
  const [tickets, setTickets] = useState({
    user_id: 0,
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    event_id: props.id,
    ticket_price: 0,
    total_price: 0,
    no_of_tickets: 1,
    payment_status: 'paid',
    paid_by: 'cash',
    event_tickets: [{}]
  })
  const [user, setUser] = useState([]);
  const [bookedby, setBookedBy] = useState('');
  const [eventData, setEventData] = useState('')
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [errors, setErrors] = useState({
    user_id: '',
    no_of_tickets: '',
    status: ''
  });
  const [bookieErr, setBookieErr] = useState('');
  const [userFilter, setUserFilter] = useState({
    page: 1,
    limit: 20,
    search: ''
  });
  const [ticketStatus, setTicketStatus] = useState('');

  const handleFormChange = (e, idx) => {
    const temp = [...tickets.event_tickets]
    if (!temp[idx]) {
      temp[idx] = {}
    }
    if (e.target.name === 'user_id') {
      const userTemp = [...user];
      if (!userTemp[idx]) {
        userTemp[idx] = {}
      }
      userTemp[idx] = e.target.value;
      setUser(userTemp);
      temp[idx]['user_id'] = e.target.value?.id;
      temp[idx]['first_name'] = e.target.value?.first_name;
      temp[idx]['last_name'] = e.target.value?.last_name;
      temp[idx]['email'] = e.target.value?.email;
      temp[idx]['phone'] = e.target.value?.cell_phone;
      if (idx === 0) {
        setTickets((prev) => ({
          ...prev,
          first_name: (e.target.value?.first_name || ''),
          last_name: (e.target.value?.last_name || ''),
          email: (e.target.value?.email || ''),
          phone: (e.target.value?.cell_phone || '')
        }))
      }
    } else {
      temp[idx][e.target.name] = e.target.value;
      if (idx === 0) {
        setTickets((prev) => ({
          ...prev,
          [e.target.name]: e.target.value
        }))
      }
    }
    temp[idx]['ticket_price'] = eventData && eventData.ticket_price;
    temp[idx]['event_id'] = props.id;
    temp[idx]['status'] = 'active';
    setTickets((prev) => ({
      ...prev,
      event_tickets: temp
    }));
  }

  const handleValidation = () => {
    let errorArr = []
    let formIsValid = true;
    let error = {};

    // if (!tickets.user_id > 0) {
    //   formIsValid = false;
    //   error['booked_by'] = messages && messages.emptySelect;
    // }
    tickets.event_tickets.forEach((element, i) => {
      if (!errorArr[i]) {
        errorArr[i] = {};
      }
      if (!element.user_id > 0 && !element.first_name && !element.last_name && !element.email && !element.phone) {
        formIsValid = false;
        errorArr[i]["user_id"] = messages && messages.emptyUser;
      }
      if (!element.first_name) {
        formIsValid = false;
        errorArr[i]["first_name"] = messages && messages.emptyField;
      }
      if (!element.last_name) {
        formIsValid = false;
        errorArr[i]["last_name"] = messages && messages.emptyField;
      }
      if (!element.email) {
        formIsValid = false;
        errorArr[i]["email"] = messages && messages.emptyField;
      }
      if (!element.phone) {
        formIsValid = false;
        errorArr[i]["phone"] = messages && messages.emptyField;
      }
      if (element.phone && element.phone.replace(/\D/g, '').length < 10) {
        formIsValid = false;
        errorArr[i]["phone"] = messages && messages.invalidPhone;
      }
    });
    setBookieErr(error);
    setErrors(errorArr)
    return formIsValid
  }

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (handleValidation()) {
      axiosApi.post(`${config.apiUrl}/tickets/create`, tickets).then(res => {
        props.backToTickets(true)
        props.isRefresh(true)
      })
    }
  }

  const getUsers = async (page_, searchString) => {
    const resp = await axiosApi.get(`${config.apiUrl}/tickets/users`, {
      params: { page: page_, search_string: searchString, limit: 20 }
    })
    return resp.data.data
  }

  const loadOptionsUsers = async (searchQuery, loadedOptions, { page }) => {
    setUserFilter(prev => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page }
      }
      return { search: searchQuery, page: page + 1 }
    })
    const users = await getUsers(page, searchQuery)
    return {
      options: users,
      hasMore: users.length === 20,
      additional: {
        page: page + 1
      }
    }
  }

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      fontSize: '13px',
      lineHeight: '16px',
      wordBreak: 'break-word'
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: 'pointer'
    })
  }

  const getEvent = id => {
    axiosApi.get(`${config.apiUrl}/events/${id}`).then(res => {
      if (res && res.data && res.data.data) {
        const resp = res.data.data;
        setEventData(resp);
        setTickets((prev) => ({
          ...prev,
          ticket_price: resp.ticket_price
        }))
      }
    })
  }

  const totalAmount = useMemo(() => {
    const total = +(tickets.event_tickets.length * (+eventData.ticket_price ? +eventData.ticket_price : 0))
    return total
  }, [tickets.event_tickets.length, eventData.ticket_price])

  const pushOne = () => {
    const temp = [...tickets.event_tickets]
    temp.push({})
    setTickets((prev) => ({
      ...prev,
      no_of_tickets: temp.length,
      event_tickets: temp
    }));
  }

  const removeOne = idx => {
    const temp = [...tickets.event_tickets];
    temp.splice(idx, 1);
    setTickets((prev) => ({
      ...prev,
      no_of_tickets: temp.length,
      event_tickets: temp
    }));
    const userTemp = [...user];
    userTemp.splice(idx, 1);
    setUser(userTemp);
  }

  const changTicketStatus = (status) => {
    if (props && props.isEdit && props.isEdit.data) {
      const ticketId = props.isEdit.data.id;
      axiosApi.put(`${config.apiUrl}/tickets/${status}/${ticketId}`)
        .then((res) => {
          setTicketStatus(status);
        })
    }
  }

  useEffect(() => {
    if (props.id) {
      getEvent(props?.id)
    }
  }, [props.id])

  useEffect(() => {
    if (props && props.isEdit && props.isEdit.data) {
      const val = props.isEdit.data;
      const userTemp = [];
      setTickets((prev) => ({
        ...prev,
        event_id: val?.id,
        payment_status: val?.payment_status,
        ticket_price: val?.ticket_price,
        total_price: val?.total_price,
        user_id: val?.user_id,
        event_tickets: val?.event_tickets
      }))
      if (val.event_tickets && val.event_tickets.length) {
        val.event_tickets.forEach(element => {
          userTemp.push(element.user);
        });
        setUser(userTemp);
      }
      if (val?.payment_status) {
        setTicketStatus(val?.payment_status);
      }
      val.full_name = val.booked_by;
      setBookedBy(val);
    }
  }, [props.isEdit.data])

  useEffect(() => {
    handleValidation()
  }, [tickets])

  useEffect(() => {
    setTickets((prev) => ({
      ...prev,
      total_price: totalAmount
    }))
  }, [totalAmount]);
  return (
    <>
      <div >
        {/* <div className='heading-wrapper ns-header-wrapper'>
            <button
              onClick={() => props.backToTickets(true)}
              className='btn with-icon'
            >
              {' '}
              <img src={backArrow} alt='' /> Back to Tickets
            </button>
          </div> */}
        <div className='mul-form'>
          <div className='cs-row'>
            <div className='cs-col-12 new-sec-title'>
              <h2>Book tickets for</h2>
            </div>
          </div>
          {tickets && tickets.event_tickets.length
            ? tickets.event_tickets.map((ticket, idx) => {
              return (
                <div className='cs-row' key={idx}>
                  <div className='cs-col-2 tab-half-fluid mob-fluid'>
                    <div className='mul-input-field'>
                      <label htmlFor=''>
                        User <sup>*</sup>
                      </label>
                      <AsyncPaginate
                        className='multivalue-dropdown'
                        value={user[idx] ? user[idx] : ''}
                        loadOptions={loadOptionsUsers}
                        getOptionValue={option => option.id}
                        getOptionLabel={option => option.full_name}
                        onChange={option => {
                          handleFormChange(
                            {
                              target: {
                                name: 'user_id',
                                value: option
                              }
                            },
                            idx
                          )
                          // setFormData((prev) => ({ ...prev, user_id: (option?.id || 0) }))
                        }}
                        placeholder='Search User'
                        additional={{
                          page: 1
                        }}
                        debounceTimeout={1000}
                        styles={customStyles}
                        noOptionsMessage={() => 'No Users Found.'}
                        isClearable={true}
                      />
                      <span className='error'>
                        {formSubmitted && errors[idx]?.user_id}
                      </span>
                    </div>
                  </div>
                  <div className='cs-col-2 tab-half-fluid mob-fluid'>
                    <div className='mul-input-field'>
                      <label htmlFor=''>
                        First Name <sup>*</sup>
                      </label>
                      <input
                        name='first_name'
                        value={ticket?.first_name ? ticket?.first_name : ''}
                        onChange={e => handleFormChange(e, idx)}
                        type='text'
                        placeholder='First Name'
                        disabled={
                          ticket && ticket.user_id ? true : false
                        }
                      />
                      <span className='error'>
                        {formSubmitted && errors[idx]?.first_name}
                      </span>
                    </div>
                  </div>
                  <div className='cs-col-2 tab-half-fluid mob-fluid'>
                    <div className='mul-input-field'>
                      <label htmlFor=''>
                        Last Name <sup>*</sup>
                      </label>
                      <input
                        name='last_name'
                        value={ticket?.last_name ? ticket?.last_name : ''}
                        onChange={e => handleFormChange(e, idx)}
                        type='text'
                        placeholder='Last Name'
                        disabled={
                          ticket && ticket.user_id ? true : false
                        }
                      />
                      <span className='error'>
                        {formSubmitted && errors[idx]?.last_name}
                      </span>
                    </div>
                  </div>
                  <div className='cs-col-2 tab-half-fluid mob-fluid'>
                    <div className='mul-input-field'>
                      <label htmlFor=''>
                        Email <sup>*</sup>
                      </label>
                      <input
                        name='email'
                        value={ticket?.email ? ticket?.email : ''}
                        onChange={e => handleFormChange(e, idx)}
                        type='text'
                        placeholder='Email'
                      />
                      <span className='error'>
                        {formSubmitted && errors[idx]?.email}
                      </span>
                    </div>
                  </div>
                  <div className='cs-col-2 tab-half-fluid mob-fluid'>
                    <div className='mul-input-field'>
                      <label htmlFor=''>
                        Phone <sup>*</sup>
                      </label>
                      <NumberFormat
                        placeholder='Enter phone'
                        format={phoneNumberMask}
                        mask='_'
                        name='phone'
                        value={ticket?.phone ? ticket?.phone : ''}
                        onChange={e => handleFormChange(e, idx)}
                      />
                      <span className='error'>
                        {formSubmitted && errors[idx]?.phone}
                      </span>
                    </div>
                  </div>
                  {props && props.isEdit && !props.isEdit.open && idx === tickets.event_tickets.length - 1 && idx + 1 < props.leftTickets && <div className='cs-col-1 cs-col-1-rs'>
                    <div className='mul-input-field'>
                      <icon
                        className='btn'
                        onClick={() => pushOne()}
                      >
                        <img src={add} alt='' />
                      </icon>
                    </div>
                  </div>}
                  {props && props.isEdit && !props.isEdit.open && tickets.event_tickets.length > 1 && (
                    <div className='cs-col-1 cs-col-1-rs'>
                      <div className='mul-input-field'>
                        <icon
                          className='btn'
                          onClick={() => removeOne(idx)}
                        >
                          <img src={close} alt='' />
                        </icon>
                      </div>
                    </div>
                  )}
                </div>
              )
            })
            : ''}

          <div className='cs-row'>
            <div className="cs-col-3 tab-half-fluid mob-fluid">
              <div className="mul-input-field">
                <label htmlFor="">Booked By</label>
                <AsyncPaginate
                  className='multivalue-dropdown'
                  loadOptions={loadOptionsUsers}
                  value={bookedby}
                  getOptionValue={option => option.id}
                  getOptionLabel={option => option.full_name}
                  onChange={option => {
                    setTickets((prev) => ({
                      ...prev, 
                      user_id: (option?.id || 0),
                      first_name: (option?.first_name || ''),
                      last_name: (option?.last_name || ''),
                      email: (option?.email || ''),
                      phone: (option?.cell_phone || '')
                    })); 
                    setBookedBy(option);
                  }}
                  placeholder='Search User'
                  additional={{
                    page: 1
                  }}
                  debounceTimeout={1000}
                  styles={customStyles}
                  noOptionsMessage={() => 'No Users Found.'}
                  isClearable={true}
                />
                <span className="error">{formSubmitted && bookieErr["booked_by"]}</span>
              </div>
            </div>
          </div>

          <div className='payment-detail-section'>
            <div className='cs-row'>
              <div className='cs-col-12 new-sec-title'>
                <h2>Payment Detail</h2>
              </div>
            </div>
            
            <div className='cs-row'>
              <div className='cs-col-12'>
                <div className='payment-summary-card'>
                  <div className='payment-summary-row'>
                    <span className='summary-label'>Tickets Available</span>
                    <span className='summary-value'>
                      <span className='ticket-available-badge'>
                        {props?.leftTickets || 0} left
                      </span>
                    </span>
                  </div>
                  
                  { eventData && eventData.ticket_price ? 
                    <>
                      <div className='payment-summary-row'>
                        <span className='summary-label'>
                          Unit Price
                        </span>
                        <span className='summary-value'>
                          {formatNumberToCurrency(eventData?.ticket_price)}
                        </span>
                      </div>

                      <div className='payment-summary-row'>
                        <span className='summary-label'>
                          Quantity
                        </span>
                        <span className='summary-value'>
                           {tickets.event_tickets.length}
                        </span>
                      </div>
                      
                      <div className='payment-summary-row total-row'>
                        <span className='summary-label'>Total Payable</span>
                        <span className='summary-value total-value'>
                          {formatNumberToCurrency(totalAmount)}
                        </span>
                      </div>
                    </> : null
                  }
                </div>
              </div>
            </div>
          </div>
          {!props?.isEdit.open && (
            <div className='cs-col-12 p-30'>
              <div className='btn-group btn-group-start'>
                <button
                  onClick={() => handleSubmit()}
                  className='btn btn-pri'
                >
                  Save
                </button>
                <button
                  onClick={() => props.backToTickets(true)}
                  className='btn btn-sec'
                >
                  {' '}
                  Cancel{' '}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
export default withRouter(AddTicket)
